import Vue from 'vue'
// import VueSplide from '@splidejs/vue-splide'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

// Vue.use(VueSplide)
Vue.component('VSplide', Splide)
Vue.component('VSplideSlide', SplideSlide)
